<template lang="pug">
  div(data-testid="prof-set")
    section.content-header
      h1 プロフィール変更
      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li.active プロフィール変更

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit", data-testid="-btn-submit") 変更
            |
            |
            router-link(:to="{name: 'top'}")
              button.btn.btn-default(data-testid="-btn-back") キャンセル

        +btnbar

        .box.box-widget

          .box-header.with-border
            .box-title システム情報

          .box-body
            loading(v-if="!initialized" :height="100")
            .row(v-else)
              .col-md-8.col-md-offset-2
                .form-group
                  label.control-label(for="loginid") ログインID
                    span.bcard-required (*)
                  p.form-control-static(v-if="isFieldView['loginid']") {{system.loginid || app_lang.NO_INPUT}}
                  input.form-control(v-else, type="text", name="loginid", id="loginid", v-model="system.loginid", :maxlength="maxlengths.loginid", required)
                .form-group
                  label.control-label(for="word_") パスワード
                  p.form-control-static(v-if="isFieldView['word']") {{system.word_ || app_lang.NO_INPUT}}
                  input.form-control(v-else, type="password", name="word_", id="word_", v-model="system.word_", :maxlength="maxlengths.word", @input="checkNewWord")
                .form-group
                  label.control-label(for="word_conf") パスワード (確認用)
                  p.form-control-static(v-if="isFieldView['word']") {{system.word_conf || app_lang.NO_INPUT}}
                  input.form-control(v-else, type="password", name="word_conf", id="word_conf", v-model="system.word_conf", :maxlength="maxlengths.word", @input="checkNewWord")
                .form-group
                  label.control-label(for="defgroup") 代表組織
                  span(v-if="system.groups.length > 0")
                    p.form-control-static(v-if="isFieldView['defgroup']") {{getDefgroupName() || app_lang.NO_SELECT}}
                    select.form-control(v-else, name="defgroup", v-model="system.defgroup")
                      option(v-for="item in system.groups", :value="item.id", :key="item.id") {{item.name}}
                  span(v-else)
                    p.text-muted 代表組織はありません。

        .box.box-widget
          //- 名刺情報入力エリア
          user-data(
            v-model="profile",
            :is-model-initialized="initialized",
            :file-view-mode="false",
            :area-title="title_profile",
            :nochg-fields="nochgFields",
            :use-image-crop="false"
          )

        +btnbar
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import UserData from '@/components/organisms/UserForm'
import Loading from '@/components/molecules/Loading'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ProfileSettingRepository = RepositoryFactory.get('profiles')

export default {
  name: 'ProfileSetting',
  components: { AppMessages, UserData, Loading },
  mixins: [ mixinForm ],
  data: function () {
    return {
      title_profile: 'プロフィール情報',
      initialized: false,
      system: {
        loginid: '',
        word_: '',
        word_conf: '',
        defgroup: '',
        groups: []
      },
      // BcardDataに渡す
      profile: {
        last_name: '',
        first_name: '',
        last_kana: '',
        first_kana: '',
        corporate_name: '',
        corporate_kana: '',
        dept: '',
        post: '',
        zipcode: '',
        address1: '',
        address2: '',
        corporate_tel: '',
        dept_tel: '',
        naisen: '',
        hand_tel: '',
        fax: '',
        mail: '',
        url: '',
        images: []
      },
      // 変更不可項目
      nochgFields: [
        'loginid',
        'word',
        // 'word_',
        // 'word_conf',
        'defgroup',
        'last_name',
        'first_name',
        'last_kana',
        'first_kana',
        'corporate_name',
        'corporate_kana',
        'dept',
        'post',
        'zipcode',
        'address1',
        'address2',
        'corporate_tel',
        'dept_tel',
        'naisen',
        'hand_tel',
        'fax',
        'mail',
        'url',
        'image'
      ],
      maxlengths: {}
    }
  },
  computed: {
    isFieldView: function () {
      if (this.nochgFields.length === 0) {
        return []
      }
      let fieldViews = []
      for (let field of this.nochgFields) {
        fieldViews[field] = true
      }
      return fieldViews
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('Users')
    this.setInitData()
    this.loadInitData()
  },
  methods: {
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      // 更新データ作成
      let bcardFormData = new FormData(this.$refs.form)

      // FileListからFileを削除するための苦肉の策
      bcardFormData = this.appendFiles(bcardFormData)

      // API実行
      ProfileSettingRepository.put(bcardFormData)
        .then(function () {
          // 成功時はTOPに遷移
          vm.$router.push({name: 'top'})
        }).catch(function (error) {
          // エラー時はメッセージを表示
          scrollTo(0, 0)
          vm.setErrorMessage(error)
        })
    },
    setInitData: function () {
      const login_user = this.$store.getState('login_user')
      this.system.loginid = login_user.loginid
      this.profile.last_name = login_user.last_name
      this.profile.first_name = login_user.first_name
      this.profile.last_kana = login_user.last_kana
      this.profile.first_kana = login_user.first_kana
      this.profile.corporate_name = login_user.corporate_name
      this.profile.corporate_kana = login_user.corporate_kana
      this.profile.dept = login_user.dept
      this.profile.post = login_user.post
      this.profile.zipcode = login_user.zipcode
      this.profile.address1 = login_user.address1
      this.profile.address2 = login_user.address2
      this.profile.corporate_tel = login_user.corporate_tel
      this.profile.dept_tel = login_user.dept_tel
      this.profile.naisen = login_user.naisen
      this.profile.hand_tel = login_user.hand_tel
      this.profile.fax = login_user.fax
      this.profile.mail = login_user.mail
      this.profile.url = login_user.url
      // this.nochgFields = []
    },
    loadInitData: function () {
      const vm = this
      let params = {
        get_rels: this.app_flag.ON
      }
      // 初期値を取得
      ProfileSettingRepository.get(params)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.system.loginid = data.loginid
          vm.system.word_ = data.word_
          vm.system.word_conf = data.word_
          vm.profile.last_name = data.last_name
          vm.profile.first_name = data.first_name
          vm.profile.last_kana = data.last_kana
          vm.profile.first_kana = data.first_kana
          vm.profile.corporate_name = data.corporate_name
          vm.profile.corporate_kana = data.corporate_kana
          vm.profile.dept = data.dept
          vm.profile.post = data.post
          vm.profile.zipcode = data.zipcode
          vm.profile.address1 = data.address1
          vm.profile.address2 = data.address2
          vm.profile.corporate_tel = data.corporate_tel
          vm.profile.dept_tel = data.dept_tel
          vm.profile.naisen = data.naisen
          vm.profile.hand_tel = data.hand_tel
          vm.profile.fax = data.fax
          vm.profile.mail = data.mail
          vm.profile.url = data.url
          vm.profile.images = data.images
          vm.profile.image_id = data.image_id
          for (let i = 0; i < data.group_users.length; i++) {
            let group = {
              id: data.group_users[i].group.id,
              name: data.group_users[i].group.name
            }
            vm.system.groups[i] = group
          }
          vm.system.defgroup = data.defgroup ? data.defgroup : ''
          vm.nochgFields = data.nochgfields
          vm.initialized = true
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    // 代表組織名を取得する
    getDefgroupName () {
      const vm = this

      for (let i = 0; i < vm.system.groups.length; i++) {
        if (vm.system.groups[i].id === vm.system.defgroup) {
          return vm.system.groups[i].name
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pages/prsettings/ProfileSetting.vue